// Intersection Observer for scroll animations
export const initScrollAnimations = () => {
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
        // Optional: stop observing after animation
        // observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe all elements with animation classes
  const animatedElements = document.querySelectorAll(
    '.fade-in-up, .fade-in, .scale-in, .slide-in-left, .slide-in-right, .stagger-item'
  );

  animatedElements.forEach((el, index) => {
    // Add stagger delay for grid items
    if (el.classList.contains('stagger-item')) {
      el.style.transitionDelay = `${index * 0.1}s`;
    }
    observer.observe(el);
  });

  return observer;
};
